import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { CssBaseline } from '@mui/material';
import App from './app/app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <CssBaseline />

    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
